import React, { createContext, useState, useContext, useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useMessageContext, createContextProvider } from './MessageContext';

export const ViewSpecificContextAPI = createContext({
  setViewContext: (contextString, description) => {},
  clearViewContext: () => {},
  currentViewContext: null,
});

export const useViewSpecificContext = () => useContext(ViewSpecificContextAPI);

export const ViewSpecificContextProvider = ({ children }) => {
  const [currentViewContext, setCurrentViewContext] = useState(null); // { contextString, description }
  const { registerContextProvider } = useMessageContext();

  const setViewContext = useCallback((contextString, description) => {
    console.log("[ViewSpecificContext] Setting context:", contextString, description);
    setCurrentViewContext({ contextString, description });
  }, []);

  const clearViewContext = useCallback(() => {
    console.log("[ViewSpecificContext] Clearing context");
    setCurrentViewContext(null);
  }, []);

  useEffect(() => {
    const provider = createContextProvider('view-specific', {
      isActive: () => !!currentViewContext?.contextString,
      getContextValue: () => currentViewContext?.contextString || null,
      getDescription: () => currentViewContext?.description || null,
      priority: 30, // High priority
    });

    const unregister = registerContextProvider(provider);
    return unregister;
  }, [currentViewContext, registerContextProvider]);

  const apiValue = useMemo(() => ({
    setViewContext,
    clearViewContext,
    currentViewContext,
  }), [setViewContext, clearViewContext, currentViewContext]);

  return (
    <ViewSpecificContextAPI.Provider value={apiValue}>
      {children}
    </ViewSpecificContextAPI.Provider>
  );
};

ViewSpecificContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};